import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  item: {
    color: theme.palette.common.gray800,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  root: {
    '&$selected': {
      '& span': {
        color: theme.palette.common.blue400,
      },
      '&:hover': {
        backgroundColor: theme.palette.common.blue50,
      },
      backgroundColor: theme.palette.common.blue50,
      borderRadius: '5px',
    },
    '&:hover': {
      backgroundColor: theme.palette.common.gray100,
    },
  },
  selected: {},
}));

export default useStyles;
